<template>
  <div class="flex-1 pt-40 min-w-100 max-w-135 mx-auto flex flex-col gap-4">
    <h1 class="text-4xl font-600">
      {{t('pages.resetPassword.set_new_title')}}
    </h1>
    <t-form
      :rules="FORM_RULES"
      :data="formData"
      labelAlign="top"
      requiredMarkPosition="right"
      ref="passwordRef"
    >
      <t-form-item name="password" :label="t('pages.resetPassword.form.label.new_password')" :help="t('pages.resetPassword.form.tip.password_format')">
        <t-input
          v-model="formData.password"
          clearable
          type="password"
          :placeholder="t('global.form.placeholder.input')"
        >
          <template #prefix-icon>
            <icon-login-password />
          </template>
        </t-input>
      </t-form-item>
      <t-form-item name="passwordConfirm" :label="t('pages.resetPassword.form.label.re_enter_password')">
        <t-input
          v-model="formData.passwordConfirm"
          clearable
          type="password"
          :placeholder="t('global.form.placeholder.input')"
        >
          <template #prefix-icon>
            <icon-login-password />
          </template>
        </t-input>
      </t-form-item>
    </t-form>
    <t-button
      theme="primary"
      type="submit"
      block
      @click="handleReset"
      class="mt-2"
    >
      {{t('pages.resetPassword.send_email')}}
    </t-button>
  </div>
</template>
<script setup lang='ts'>
import type { CustomValidateResolveType, FormProps } from 'tdesign-vue-next';
import { resetPassword } from '@/api/modules/resetPassword';
import { MessagePlugin } from 'tdesign-vue-next';
definePage({
  meta: {
    layout: "login-layout"
  },
})
const{t,locale}=useI18n()
const route=useRoute()
const router=useRouter()
const passwordRef=ref()
const btnLoading=ref(false)
watch(()=>locale.value, ()=>{
    passwordRef.value.clearValidate();
})
const formData: FormProps['data'] = ref({
  password: '',
  passwordConfirm:''
});
const passwordValidator=(val:string):CustomValidateResolveType=>{
  const regex=/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,20}$/
  if(regex.test(val)){
    return true
  }else{
    return { result: false, message:t('pages.resetPassword.form.verifyError.password.format_error'), type: 'error' };
  }
}
const passwordConfirmValidator=(val:string):CustomValidateResolveType=>{
  if(val===formData.value.password){
    return true
  }else{
     return { result: false, message:t('pages.resetPassword.form.verifyError.password.password_confirm_error'), type: 'error' };
  }
}
const FORM_RULES: FormProps['rules'] = {
  password: [
    {
      required: true,
      message: t('global.form.verifyError.input.empty_error',{
        field_name:t('global.password')
      }),
    },
    {
      validator: passwordValidator,
    },
  ],
  passwordConfirm:[
   {
      required: true,
      message: t('global.form.verifyError.input.empty_error',{
        field_name:t('global.password')
      }),
    },
    {
      validator: passwordConfirmValidator,
    },
  ]
};

const handleReset=async()=>{
   const validate = await passwordRef.value.validate();
  if (validate !== true) return;
  btnLoading.value=true
    resetPassword({
        password:formData.value.password,
        code: (route.params as { code: string }).code
    }).then(res=>{
        MessagePlugin.success('Password reseted successfully!')
        router.replace('/login')
    }).finally(()=>{
      btnLoading.value=false
    })
}
onMounted(()=>{
})
</script>
<style scoped lang="less">

</style>
